import { runInAction } from 'mobx'
import * as XLSX from 'xlsx'

import { http, format, timer } from 'utils'
import { config } from 'config'
import { attendance } from 'constant'

import BaseStore from '../BaseStore'

const Url = `${config.api}/v1/user-admin/overtime`

const getColumnSize = (size) => {
  const sizeList = []
  for (let i = 0; i < size; i++) {
    const width = 18
    sizeList.push({ width })
  }

  return sizeList
}

let state
export class Overtime extends BaseStore {
  constructor() {
    super()
    this.observable({
      list: [],
      page: {
        index: 1,
        per_page: 20,
        total: 0,
      },
    })
    state = this
  }

  toQuery(query = {}) {
    const {
      index = 1,
      per_page = 20,
      user_id,
      status,
      ot_category_id,
      start_date,
      end_date,
    } = query

    let q = `index=${index}&per_page=${per_page}`

    if (status) q += `&status=${status}`
    if (user_id) q += `&user_id=${user_id}`
    if (ot_category_id) q += `&ot_category_id=${ot_category_id}`
    if (start_date) q += `&start_date=${start_date.toISOString()}`
    if (end_date) q += `&end_date=${end_date.toISOString()}`

    return q
  }

  async getList(query) {
    const { index = 1, per_page = 20 } = query
    const q = this.toQuery(query)
    const url = `${Url}/report?${q}`
    const res = await http.get(url)

    const list = res.body || []

    const { page } = this.toJS()

    page.index = index
    page.per_page = per_page

    runInAction(() => {
      state.list = list
      state.page = page
    })
  }

  async getCounter(query) {
    const q = this.toQuery(query)
    const url = `${Url}/report/counter?${q}`
    const res = await http.get(url)

    const { counter } = res.body

    runInAction(() => {
      state.page.total = counter || 0
    })
  }

  updateInList(id, doc) {
    const { list = [] } = this.toJS()
    const i = list.findIndex((it) => it.ot_req_id === id)
    if (i !== -1) {
      list[i].status = doc.status
      runInAction(() => {
        state.list = list
      })
    }
  }

  async rejectReq({ ot_req_id, reason = '' }) {
    reason = reason.trim()

    const url = `${Url}/request/${ot_req_id}/reject`
    const res = await http.put(url, { json: { reason } })

    const newDoc = res.body
    this.updateInList(ot_req_id, newDoc)
  }

  async approveReq({ ot_req_id }) {
    const url = `${Url}/request/${ot_req_id}/approve`
    const res = await http.put(url)

    const newDoc = res.body
    this.updateInList(ot_req_id, newDoc)
  }

  async export(query) {
    const q = this.toQuery({ ...query, per_page: -1 })
    const url = `${Url}/report?${q}`
    const res = await http.get(url)

    const reqList = res.body || []
    const list = reqList.map((it) => {
      const employee = `${it.name || ''} ${it.surname || ''}`
      const nickname = it.nickname || ''
      const { status, category_name, overtime_minute, amount, note, reason } =
        it

      const start_at = format.toExportDate(it.start_at)
      const end_at = format.toExportDate(it.finish_at)
      const manHour = attendance.toWorkTime(overtime_minute)
      return [
        employee,
        nickname,
        status,
        category_name,
        start_at,
        end_at,
        manHour,
        amount,
        note,
        reason,
      ]
    })

    const today = timer.get()
    const date = today.format('DDMMYY-HHmm')

    const headers = [
      'employee',
      'nickname',

      'status',
      'category name',
      'start work',
      'end work',

      'man hour',
      'amount',
      'note',
      'reason',
    ]

    list.unshift(headers)

    const ws = XLSX.utils.aoa_to_sheet(list)
    ws['!cols'] = getColumnSize(headers.length)

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, ws, 'overtime')

    XLSX.writeFile(workbook, `overtime-${date}.xlsx`)

    return list
  }
}

export default new Overtime()
